import {
  FOOTER_LICENSE,
  SUPPORT,
  TERMS_OF_SERVICE,
  PRIVACY_POLICY,
  GOOGLE_API_SERVICES
} from '../../constants/ui.labels'
import Link from '@talkdesk/cobalt-react-link'
import Box from '@talkdesk/cobalt-react-box'
import Flex from '@talkdesk/cobalt-react-flex'
import { Text } from '@talkdesk/cobalt-react-typography'
import { useTheme } from '@talkdesk/cobalt-react-theme-provider'
import { constantBuilder } from '../../utils/index'

const TalkdeskFooter = ({
  brandingSettings: { links, branding },
  showGoogleFooterLink
}) => {
  const theme = useTheme()

  return (
    <Box as="footer" padding={4} width="100%" backgroundColor={theme.gray100}>
      <Flex alignX="space-between" alignY="center" gap={4}>
        <Text size="small" color={theme.gray600}>
          {constantBuilder(FOOTER_LICENSE, {
            copyright: branding.copyright
          })}
        </Text>
        <Flex as="nav" gap={4} wrap width="auto" alignX="end">
          <Link target="_blank" href={links.support}>
            {SUPPORT}
          </Link>
          <Link target="_blank" href={links['service-terms']}>
            {TERMS_OF_SERVICE}
          </Link>
          <Link target="_blank" href={links['privacy-policy']}>
            {PRIVACY_POLICY}
          </Link>
          {showGoogleFooterLink && (
            <Link target="_blank" href={links['google-api-services']}>
              {GOOGLE_API_SERVICES}
            </Link>
          )}
        </Flex>
      </Flex>
    </Box>
  )
}

export default TalkdeskFooter
